import { Select } from 'antd';
import React from 'react';

const SelectListeDeroulant = ({ options = [], value, onChange, disabled }) => {
  const selectOptions = options.map(opt => ({
    label: opt,
    value: opt
  }));

  return (
    <Select
      options={selectOptions}
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={{ width: '100%', height:50 }}
      placeholder="Sélectionner une option"
    />
  );
};

export default SelectListeDeroulant;
